import { ClientAPI } from "@apiV2";
import { authServiceInstance } from "@auth/index";

class ClientJobsAPI {
  cFetch: any;

  setApiClient = (cFetchClient: any) => {
    this.cFetch = cFetchClient;
  };

  getJobPosts = async () => {
    return await ClientAPI.getJobPosts(authServiceInstance.getUserId());
  };

  getJobPost = async (id: any) => {
    return await ClientAPI.getJobPostById(authServiceInstance.getUserId(), id);
  };

  getJobPostShift = async ({ jobPostId, id }: any) => {
    return await ClientAPI.getJobPostShift(
      authServiceInstance.getUserId(),
      jobPostId,
      id
    );
  };

  saveJobPost = async (body: any) => {
    return await ClientAPI.jobPostSave(authServiceInstance.getUserId(), body);
  };

  acceptJobPost = async ({ jobPostId, carers, role }: any) => {
    return await ClientAPI.jobPostAccept(
      authServiceInstance.getUserId(),
      jobPostId,
      carers,
      role
    );
  };

  rejectJobPost = async ({ jobPostId, carers }: any) => {
    return await ClientAPI.jobPostReject(
      authServiceInstance.getUserId(),
      jobPostId,
      carers
    );
  };

  acceptJobPostShift = async ({ jobPostId, id, carers }: any) => {
    return await ClientAPI.jobPostShiftAccept(
      authServiceInstance.getUserId(),
      jobPostId,
      id,
      carers
    );
  };

  rejectJobPostShift = async ({ jobPostId, id, carers }: any) => {
    return await ClientAPI.jobPostShiftReject(
      authServiceInstance.getUserId(),
      jobPostId,
      id,
      carers
    );
  };

  cancelJobPost = async ({ jobPostId, ...payload }: any) => {
    return await ClientAPI.jobPostCancel(
      authServiceInstance.getUserId(),
      jobPostId,
      payload
    );
  };
  openJobPosts = async () => {
    return await ClientAPI.getOpenJobPosts();
  };
}

export default new ClientJobsAPI();
